export default function HowItWorksSection() {
  const steps = [
    { num: '01', icon: 'ri-search-line', title: 'Wybierz kategorię produktu', desc: 'Przeglądaj nasze kategorie i znajdź interesujący Cię rodzaj produktów.' },
    { num: '02', icon: 'ri-eye-line', title: 'Znajdź interesujący produkt', desc: 'Przejrzyj listę starannie wyselekcjonowanych produktów w wybranej kategorii.' },
    { num: '03', icon: 'ri-shield-check-line', title: 'Sprawdź informacje QC', desc: 'Zapoznaj się z informacjami o jakości i zdjęciami kontrolnymi produktów.' },
    { num: '04', icon: 'ri-external-link-line', title: 'Przejdź do Kakobuy', desc: 'Kliknij w link i przejdź bezpośrednio do strony produktu na platformie.' },
    { num: '05', icon: 'ri-shopping-cart-line', title: 'Zrealizuj zakup', desc: 'Dokonaj zakupu bezpiecznie, korzystając ze sprawdzonych procedur i wskazówek.' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-3 text-center">
          Jak działa Kakobuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Prosty proces w pięciu krokach — od wyboru kategorii do bezpiecznego zakupu.
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-background-300/60"></div>
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-3">
            {steps.map((step) => (
              <div key={step.num} className="relative flex flex-col items-center text-center p-4">
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-lg mb-3 relative z-10">
                  {step.num}
                </span>
                <h4 className="text-sm font-semibold text-foreground-950 mb-1">{step.title}</h4>
                <p className="text-xs text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}